module.exports = __webpack_public_path__ + "static/media/krx-dream.73fcc809.png";